var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createDecorator } from 'vue-class-component';
export function Obey(eventName, channelName) {
    return function (target, key, descriptor) {
        createDecorator(function (componentOptions, k) {
            var _a, _b;
            componentOptions.phoenix = !componentOptions.phoenix ? Object.create(null) : componentOptions.phoenix;
            if (componentOptions.phoenix) {
                if (channelName) {
                    componentOptions.phoenix[channelName] = componentOptions.phoenix[channelName]
                        ? __assign({}, componentOptions.phoenix[channelName], (_a = {}, _a[eventName] = key, _a)) : (_b = {},
                        _b[eventName] = key,
                        _b);
                }
                else {
                    componentOptions.phoenix[eventName] = key;
                }
            }
        })(target, key);
    };
}
//# sourceMappingURL=obey.js.map